module.exports = __webpack_public_path__ + "img/WebApp.0c96ea3f.svg";